<template>

    <div v-if="null !== article">
        <div class="quiz__campaign__endpoint_article-top">
            <a v-if="article.links.view" class="article-image-link" :href="article.links.view" :title="content.title">
                <img v-if="article.cover_image" :src="article.cover_image.image_urls.large" :alt="article.cover_image.alt_text"/>
            </a>
            <div class="quiz__campaign__endpoint_article-content subtitle">
                <h4 class="quiz__campaign__endpoint-subtitle">{{ content.title }}</h4>
            </div>
        </div>
        <div class="quiz__campaign__endpoint_article-content title">
            <h2 class="quiz__campaign__endpoint-title">{{ article.title }}</h2>
            <a v-if="article.links.view" :href="article.links.view" class="quiz__campaign__endpoint-button quiz__campaign__endpoint-button-primary">View</a>
        </div>
    </div>
</template>
<script>
export default {
    props: ['content'],
    mounted(){
        this.article = this.content.data[0];
    },
    data(){
        return {
            article: null
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/article.vue